import { useState, useEffect } from 'react';
import axios from '../axios';
import { useAppSelector } from '../store';
import { Rubric } from '../types';

export const useAuthInitialization = () => {
    // Auth initialization (refreshAuth) is handled once by AppContent.
    // This hook only reacts to the resulting state.
    const { initialized, user } = useAppSelector((state) => state.auth);
    const [userRubricsReady, setUserRubricsReady] = useState(false);
    const [userRubrics, setUserRubrics] = useState<Rubric[]>([]);

    // Step 2: Load user rubrics after auth is initialized
    useEffect(() => {
      const loadRubrics = async () => {
        if (!initialized) return;

        if (initialized && !user) {
          setUserRubricsReady(true);
          return;
        }

        if (user?.id) {
          try {
            const resp = await axios.get<Rubric[]>(`/api/admin/users/${user.id}/selected-rubrics`);
            setUserRubrics(resp.data);
          } catch (err) {
            console.error('Error fetching user rubrics:', err);
          }
        }

        setUserRubricsReady(true);
      };

      loadRubrics();
    }, [initialized, user?.id]);

    return {
      authInitialized: initialized,
      userRubricsReady,
      isFullyReady: initialized && userRubricsReady,
      userRubrics
    };
};
